import React, { Component } from "react";
import LoginFediverse from "../components/LoginFediverse";
import Header from "../components/Header";
import Footer from "../components/Footer";
import * as Constants from '../Constants';

export default class Login extends Component {

  

  render() {

    return (
      <div className="content">
        <Header />
        <div className="mt-4"/>
        <h3 className="text-center logo-gradient">1. Login with Mastodon</h3>
        <div className="mt-4"/>
        <LoginFediverse
          type="Mastodon"
          placeholder="Example: mastodon.social"
          url={Constants.URL_BASE + "/redirect-mastodon"}
          icon=<i className="bi bi-mastodon"/>
          permision="read write:statuses"
          />
        <Footer />
      </div>
      
    );
  }
}
